import React from 'react';
import { FunctionComponent } from 'react';
import styled from 'styled-components/macro';
import { theme } from '../../theme';
import pageElement from '../../components/basic/PageElement';
import LocalizationButtons from '../../components/header/LocalizationButtons';
import YSaatioLogo from './YSaatioLogo';
import PaddedContent from '../../components/housing/PaddedContent';

const Container = styled.div`
  background-color: ${theme().colors.m2White};
  min-height: 100vh;
`;

const Header = styled.div`
  ${pageElement};
  display: flex;
  align-content: space-between;
  background-color: ${theme().colors.m2White};
  padding: 30px 0;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.m2White};
`;

const IconLinks = styled.div`
  display: flex;
  flex: 1;
`;

const YSaatioUnauthenticatedPageContainer: FunctionComponent = ({ children }) => {
  return (
    <Container>
      <Header>
        <IconLinks>
          <YSaatioLogo />
        </IconLinks>
        <LocalizationButtons />
      </Header>
      <PaddedContent>
        <ContentContainer>{children}</ContentContainer>
      </PaddedContent>
    </Container>
  );
};

export default YSaatioUnauthenticatedPageContainer;
